import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'

const DailyTabContent = ({
	RadioGroup,
	RadioButton,
	selectedAmount,
	selectedMonthlyGateway
}) => {
	const [radioValue, setRadioValue] = useState('')

	useEffect(() => {
		setRadioValue(selectedMonthlyGateway === 'bkash_recurring' ? '1' : '10')
	}, [selectedMonthlyGateway])

	const handleRadioChange = e => {
		setRadioValue(e.target.value)
		selectedAmount(e.target.value)
	}

	return (
		<>
			<RadioGroup
				buttonStyle='solid'
				size='large'
				style={{
					flexDirection: 'column',
					width: '100%'
				}}
				value={radioValue}
				onChange={handleRadioChange}
			>
				{selectedMonthlyGateway === 'bkash_recurring' ? (
					<Row>
						<Col xl={8} xs={12}>
							<RadioButton
								value='1'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								1 ৳
							</RadioButton>
						</Col>
						<Col xl={8} xs={12}>
							<RadioButton
								value='10'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								10 ৳
							</RadioButton>
						</Col>
						<Col xl={8} xs={12}>
							<RadioButton
								value='20'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								20 ৳
							</RadioButton>
						</Col>
						<Col xl={8} xs={12}>
							<RadioButton
								value='50'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								50 ৳
							</RadioButton>
						</Col>
						<Col xl={8} xs={12}>
							<RadioButton
								value='100'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								100 ৳
							</RadioButton>
						</Col>
						<Col xl={8} xs={12}>
							<RadioButton
								value='0'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								Other
							</RadioButton>
						</Col>
					</Row>
				) : (
					<Row>
						<Col xl={8} xs={12}>
							<RadioButton
								value='10'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								10 ৳
							</RadioButton>
						</Col>
						<Col xl={8} xs={12}>
							<RadioButton
								value='20'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								20 ৳
							</RadioButton>
						</Col>
						<Col xl={8} xs={12}>
							<RadioButton
								value='50'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								50 ৳
							</RadioButton>
						</Col>
						<Col xl={8} xs={12}>
							<RadioButton
								value='100'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								100 ৳
							</RadioButton>
						</Col>
						<Col xl={8} xs={12}>
							<RadioButton
								value='500'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								500 ৳
							</RadioButton>
						</Col>
						<Col xl={8} xs={12}>
							<RadioButton
								value='0'
								style={{
									width: '100%',
									height: 60,
									paddingTop: 5,
									paddingLeft: 15
								}}
							>
								Other
							</RadioButton>
						</Col>
					</Row>
				)}
			</RadioGroup>
		</>
	)
}

export default DailyTabContent
